export enum SponsorCategory {
    Restaurant = 1,
    Workshop = 2,
    Trade = 3,
    Construction = 4,
    IndividualCompany = 5,
    Other = 6,
}
